/**
 * Language Context - Using react-i18next
 * 
 * We're using react-i18next library for translations:
 * - All translations are in src/i18n/locales/ (en.json, es.json)
 * - Uses i18next for translation management
 * - Components use useTranslation() hook from react-i18next
 * 
 * All translations are centralized in JSON files:
 * - src/i18n/locales/en.json (English)
 * - src/i18n/locales/es.json (Spanish)
 */

import React, { createContext, useContext } from 'react';
import i18n from '../i18n/config';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLang);
  };

  const value = {
    language: i18n.language,
    setLanguage: (lang) => i18n.changeLanguage(lang),
    toggleLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

